import { ANALYTICS_EVENTS } from '../../events'
import createAnalyticsStatic, { EventProps } from '../createAnalyticsEvent'

export type OnboardingKycSkippedProps = EventProps

/**
 * @event onboarding_kyc_skipped
 * @description Emitted when the KYC process is skipped.
 */
export const OnboardingKycSkippedAnalytics = createAnalyticsStatic<OnboardingKycSkippedProps>(
    ANALYTICS_EVENTS.ONBOARDING.ONBOARDING_KYC_SKIPPED,
)

export default OnboardingKycSkippedAnalytics
